module.exports = __webpack_public_path__ + "static/media/logo.e67299a5.jpg";